/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeDefinitionDTO } from './AttributeDefinitionDTO';
import {
    AttributeDefinitionDTOFromJSON,
    AttributeDefinitionDTOFromJSONTyped,
    AttributeDefinitionDTOToJSON,
} from './AttributeDefinitionDTO';

/**
 * 
 * @export
 * @interface AttributesSearchResultDTO
 */
export interface AttributesSearchResultDTO {
    /**
     * 
     * @type {Array<AttributeDefinitionDTO>}
     * @memberof AttributesSearchResultDTO
     */
    entries: Array<AttributeDefinitionDTO>;
}

/**
 * Check if a given object implements the AttributesSearchResultDTO interface.
 */
export function instanceOfAttributesSearchResultDTO(value: object): value is AttributesSearchResultDTO {
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function AttributesSearchResultDTOFromJSON(json: any): AttributesSearchResultDTO {
    return AttributesSearchResultDTOFromJSONTyped(json, false);
}

export function AttributesSearchResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributesSearchResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(AttributeDefinitionDTOFromJSON)),
    };
}

export function AttributesSearchResultDTOToJSON(value?: AttributesSearchResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entries': ((value['entries'] as Array<any>).map(AttributeDefinitionDTOToJSON)),
    };
}

